import { useState, useEffect, useCallback } from "react";
import { getClientHistory, HISTORY_EVENT } from "../utils/holdingsHistory";

// Reactive read of a single client's monthly snapshot history.
export function useHoldingsHistory(clientId) {
  const load = useCallback(() => (clientId ? getClientHistory(clientId) : []), [clientId]);
  const [snapshots, setSnapshots] = useState(load);

  useEffect(() => {
    setSnapshots(load());
    const onUpdate = () => setSnapshots(load());
    window.addEventListener(HISTORY_EVENT, onUpdate);
    window.addEventListener("pension-data-synced", onUpdate);
    return () => {
      window.removeEventListener(HISTORY_EVENT, onUpdate);
      window.removeEventListener("pension-data-synced", onUpdate);
    };
  }, [load]);

  return snapshots; // sorted ascending by period
}
